var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":("/lab/" + (_vm.lab.id))}},[_c('div',{staticClass:"lab",style:(("background-image: url(" + _vm.eyecatch + ")"))},[_c('div',{staticClass:"description"},[_c('h2',[_vm._v(_vm._s(_vm.lab.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }